@if ((facebookFollowers$ | async)?.length != 0) {
  @for (facebookFollower of facebookFollowers$ | async; track facebookFollower) {
    @if (facebookFollower.source !== null) {
      @if (facebookFollower.url === null || url == facebookFollower.url) {
        <app-aggregated-amount-item
          name="{{ (selectedArtist$ | async)?.nameMain }}"
          account="（ {{
            facebookFollower.userName == null
              ? facebookFollower.objectId
              : facebookFollower.userName
          }}  ）"
          icon="./assets/facebook.png"
          [amount]="facebookFollower.units"
          unit="フォロワー数"
          [rate]="facebookFollower.rate"
          [link]="facebookFollower.url"
          [hasAmount]="facebookFollower.hasUnits"
          [loading]="loading$ | async"
          help="{{
            facebookFollower.source === 'shareablee' ? 'Shareablee' : 'Chartmetric'
          }}に登録された {{
            !facebookFollower.url ? 'Facebook' : facebookFollower.url
          }} のフォロワー数です。選択期間内に取得できた最新の値を表示しています。"
          [dataCollections]="dataCollections$ | async"
          [dataCollectLoading]="dataCollectLoading$ | async"
          [isDecimal]="true"
        ></app-aggregated-amount-item>
      }
    } @else {
      <app-aggregated-amount-item
        name="{{ (selectedArtist$ | async)?.nameMain }}"
        icon="./assets/facebook.png"
        [amount]=""
        unit="フォロワー数"
        [rate]=""
        [link]=""
        [hasAmount]="false"
        [loading]="loading$ | async"
        help="Facebook のフォロワー数です。選択期間内に取得できた最新の値を表示しています。"
        [dataCollections]="dataCollections$ | async"
        [dataCollectLoading]="dataCollectLoading$ | async"
        ></app-aggregated-amount-item
        >
      }
    }
  } @else {
    <app-aggregated-amount-item
      name="{{ (selectedArtist$ | async)?.nameMain }}"
      icon="./assets/facebook.png"
      [amount]=""
      unit="フォロワー数"
      [rate]=""
      [link]=""
      [hasAmount]="false"
      [loading]="loading$ | async"
      help="Facebook のフォロワー数です。選択期間内に取得できた最新の値を表示しています。"
      [dataCollections]="dataCollections$ | async"
      [dataCollectLoading]="dataCollectLoading$ | async"
      ></app-aggregated-amount-item
      >
    }

